function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 4.4385,
  y: 4.556,
  width: 29.4126,
  height: 4.3659
}), /*#__PURE__*/React.createElement("rect", {
  x: 4.4386,
  y: 54.1193,
  width: 8.5759,
  height: 2.1535
}), /*#__PURE__*/React.createElement("rect", {
  x: 4.4386,
  y: 57.5038,
  width: 5.7652,
  height: 2.1535
}), /*#__PURE__*/React.createElement("rect", {
  x: 21.4071,
  y: 54.1193,
  width: 8.5759,
  height: 2.1535
}), /*#__PURE__*/React.createElement("rect", {
  x: 21.407,
  y: 57.5038,
  width: 5.7652,
  height: 2.1535
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.2656,
  y: 54.1193,
  width: 8.5759,
  height: 2.1535
}), /*#__PURE__*/React.createElement("rect", {
  x: 37.2656,
  y: 57.5038,
  width: 5.7652,
  height: 2.1535
}), /*#__PURE__*/React.createElement("rect", {
  x: 4.4386,
  y: 10.3973,
  width: 49.586,
  height: 10.1824
}), /*#__PURE__*/React.createElement("rect", {
  x: 4.4386,
  y: 22.5703,
  width: 49.586,
  height: 29.2999
}));

var SvgTemplate2 = function SvgTemplate2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Lager_1",
    x: "0px",
    y: "0px",
    width: "58.7313px",
    height: "64.0466px",
    viewBox: "0 0 58.7313 64.0466",
    enableBackground: "new 0 0 58.7313 64.0466",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTemplate2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/template-2.61baca0b.svg";
export { ForwardRef as ReactComponent };